import { render, staticRenderFns } from "./CampaignsTeamMember.vue?vue&type=template&id=ecf26920&lang=pug"
import script from "./CampaignsTeamMember.vue?vue&type=script&lang=js"
export * from "./CampaignsTeamMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports